import { Button, Grid, TextField, Typography } from "@mui/material";
import SubCard from "ui-component/cards/SubCard";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const FilterComponent = (props) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <SubCard>
                    <Grid container spacing={2} justifyContent="space-between">
                        <Grid item md={6} xs={12}>
                            <Grid container spacing={2}>
                                
                                <Grid item md={6} xs={12}>
                                    <Typography variant="h5" sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600}>
                                        Search
                                    </Typography>
                                    <TextField
                                        size="small"
                                        fullWidth
                                        id="outlined-basic"
                                        variant="outlined"
                                        value={props.data?.value}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                border: '2px solid #A9A9A980 50%',
                                                borderRadius: '8px',
                                            },
                                            '& fieldset': {
                                                borderColor: '#A9A9A980',
                                                borderRadius: '8px',
                                            },
                                        }}
                                        onChange={(e)=>props.handleChange("value", e.target.value)}
                                    />
                                </Grid>

                                <Grid item md={6} xs={12}>
                                    <Typography variant="h5" sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600}>
                                        FOS
                                    </Typography>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={props.data&&props.data.key?props.data.key : "select"}
                                            onChange={(e) =>
                                                props.handleChange("key", e.target.value === "select" ? null : e.target.value)
                                            }
                                            sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: '2px solid #A9A9A980 50%',
                                                    borderRadius: '8px',
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    border: '2px solid #A9A9A980 50%',
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    border: '2px solid #A9A9A980 50%',
                                                },
                                            }}
                                            onChnage={(e)=>props.handleChange("key", e.target.value)}
                                        >
                                            <MenuItem value="select">Select Filter Type</MenuItem>
                                            <MenuItem value="fos_name">FOS Name</MenuItem>
                                            <MenuItem value="fos_code">FOS Code</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item md={4} xs={12} >
                            <Grid container spacing={2} justifyContent="flex-end">
                                <Grid item md={4} xs={12} mt={3.5}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        size="small"
                                        disabled={props.data&&props.data.value&&props.data.key?false:true}
                                        sx={{
                                            backgroundColor: "#688B2A",
                                            color: "#FFFFFF",
                                            borderRadius: "6px",
                                            "&:hover": {
                                                backgroundColor: "#688B2A",
                                            },
                                        }}
                                        onClick={() => props.handleSearch()}
                                    >Search</Button>
                                </Grid>
                                <Grid item md={4} xs={12}  mt={3.5}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            backgroundColor: "#592375",
                                            color: "#FFFFFF",
                                            borderRadius: "6px",
                                            "&:hover": {
                                                backgroundColor: "#592375",
                                            },
                                        }}
                                        onClick={() => props.handleClear()}
                                    >Clear</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </SubCard>
            </Grid>
        </Grid>
    );
};

export default FilterComponent;
